import { IconSvgProps } from "../types";
export const Megaphone = ({ size }: IconSvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        id="icon-megaphone"
        width={size}
        height={size}
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M23.5166 8.72656L16.2433 11.6366V19.3966L23.5166 22.3066V8.72656Z"
            fill="#1868DB"
        />
        <path
            d="M18.1066 12.1201V18.9001H14.3033V23.2734H11.3933V18.9001H8.48328V12.1201H18.1066Z"
            fill="#FCA700"
        />
        <path
            d="M18.1066 12.1201H16.2433V18.8968H18.1066V12.1201Z"
            fill="#AE2A19"
        />
    </svg>
);
